import i18n from "../../i18n";

// Help & Support — the Google Form opened from the supervisor drawer, the
// login/forgot/reset footer and the web-worker help page, pre-filled with the
// signed-in user's identity so support has context without them retyping it.
//
// One form per UI language. The French and Spanish forms are copies of the
// English one and keep the same "entry.*" ids, so only the form id changes.
//
// Prefill params (Google Form "entry.*" ids):
//   entry.1364207955 → APP_NAME    (worker/supervisor name)
//   entry.1390723809 → APP_CONTACT (email or phone used at authentication)
//   entry.1669251961 → APP_COMPANY (company / organization name)
//   entry.1585366341 → APP_TIER    (AC-1 = Supervisor, AC-2 = Worker)
const HELP_FORM_IDS: Record<string, string> = {
	en: "1FAIpQLSeQwAdg-QQ1KchUSa2WqmS3lOuZfW1PAS_xampFhgEqHM7u-A",
	fr: "1FAIpQLSd4xIVo74jFNF9IDq4QBEOkFY0kficXXhPcV1l9XU-Y2-jUlw",
	es: "1FAIpQLSeMe2MpbmR8V9tO5srpy2Ely9wcGvyE6Q3c-jtC-hlJDrWjxA",
};

// App tier codes for the support form.
export const HELP_TIER_SUPERVISOR = "AC-1";
export const HELP_TIER_WORKER = "AC-2";

export interface HelpSupportUrlOptions {
	name?: string;
	contact?: string;
	org?: string;
	tier?: string;
	/** Language tag ("fr", "es-ES", …). Defaults to the active i18n language. */
	language?: string;
	/** Add `embedded=true` for rendering inside an iframe. */
	embedded?: boolean;
}

/**
 * Resolve a language tag ("fr", "fr-CA", "es-ES", …) to the form for that
 * language. Anything unrecognised falls back to English.
 */
export const getHelpFormBase = (language?: string | null): string => {
	const code = String(language ?? "")
		.split("-")[0]
		.toLowerCase();
	const id = HELP_FORM_IDS[code] || HELP_FORM_IDS.en;
	return `https://docs.google.com/forms/d/e/${id}/viewform`;
};

/**
 * Build the pre-filled Help & Support form URL. Missing values are sent empty
 * so the form still opens.
 */
export const buildHelpSupportUrl = ({
	name = "",
	contact = "",
	org = "",
	tier = "",
	language = i18n.language,
	embedded = false,
}: HelpSupportUrlOptions = {}): string => {
	const query = [
		"usp=pp_url",
		`entry.1364207955=${encodeURIComponent(name || "")}`,
		`entry.1390723809=${encodeURIComponent(contact || "")}`,
		`entry.1669251961=${encodeURIComponent(org || "")}`,
		`entry.1585366341=${encodeURIComponent(tier || "")}`,
	];
	if (embedded) query.push("embedded=true");
	return `${getHelpFormBase(language)}?${query.join("&")}`;
};
